import React from "react"
import clsx from "clsx"

import classes from "./Card.module.scss"

const Card = props => {
  const {
    children,
    className,
    ...otherProps
  } = props

  return (
    <div
      className={clsx(classes["container"], className)}
      {...otherProps}
    >
      {children}
    </div>
  )
}

export default Card